import {GridCellSummary, SampleDetails, WellSampleDetails} from 'constants/SampleConstants';
import {EvaluatedCellError} from 'notebook/tables/excess/Evaluator';
import {Optional} from 'util/Types';

import makeEmptySampleDetails from './makeEmptySampleDetails';

export function makeBioentitySampleDetails(
  {
    id,
    name,
    displayLabel,
  }: {
    id: string;
    name: string;
    displayLabel?: string;
  },
  error?: Optional<EvaluatedCellError>
): SampleDetails {
  return {...makeEmptySampleDetails(), error, bioentityInfo: {id, name, displayLabel}};
}

export function makeBoxSampleDetails(
  {
    id,
    name,
    barcode,
  }: {
    id: string;
    name: string;
    barcode?: Optional<string>;
  },
  error?: Optional<EvaluatedCellError>
): SampleDetails {
  return {...makeEmptySampleDetails(), error, boxInfo: {id, name, barcode}};
}

export function makeContainerSampleDetails(
  {
    id,
    name,
    barcode,
  }: {
    id: string;
    name: string;
    barcode: Optional<string>;
  },
  error?: Optional<EvaluatedCellError>
): SampleDetails {
  return {...makeEmptySampleDetails(), error, containerInfo: {id, name, barcode}};
}

export function makePlateSampleDetails(
  {
    id,
    name,
    barcode,
  }: {
    id: string;
    name: string;
    barcode?: Optional<string>;
  },
  error?: Optional<EvaluatedCellError>
): SampleDetails {
  return {...makeEmptySampleDetails(), error, plateInfo: {id, name, barcode}};
}

export function makeWellSampleDetails(
  {
    id,
    name,
    barcode,
  }: {
    id: string;
    name: string;
    barcode: Optional<string>;
  },
  position: GridCellSummary | string,
  error?: Optional<EvaluatedCellError>
): WellSampleDetails {
  return {
    // Can't use "makeEmpty" here, because a well has enforced NULLs
    batchInfo: null,
    bioentityInfo: null,
    boxInfo: null,
    containerInfo: null,
    textInfo: null,
    booleanInfo: null,
    numberInfo: null,
    plateInfo: {id, name, barcode},
    position,
    error,
  };
}
